import React from "react";
import { motion } from "framer-motion";
import { StoreButton, ApkButton } from "./DownloadButtons";
import { CTA_BOTTOM } from "@/constants/plantusTestIds";

export const CtaBottom = () => {
  return (
    <section
      data-testid={CTA_BOTTOM.section}
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="relative rounded-[2rem] sm:rounded-[2.5rem] bg-forest-700 text-white px-6 sm:px-12 lg:px-20 py-16 sm:py-20 overflow-hidden"
        >
          {/* Decorative dots */}
          <div
            className="absolute inset-0 opacity-[0.15]"
            style={{
              backgroundImage:
                "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.6) 1px, transparent 0)",
              backgroundSize: "26px 26px",
            }}
          />
          {/* Terracotta blob */}
          <div className="absolute -top-20 -right-20 w-72 h-72 bg-terracotta/30 rounded-full blur-3xl" />

          <div className="relative max-w-2xl">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-terracotta/90 mb-4">
              Jetzt kostenlos testen
            </div>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
              Bereit für die digitale Dokumentations­pflicht?
            </h2>
            <p className="mt-5 font-body text-base sm:text-lg text-white/75 max-w-lg">
              Erstellen Sie mit einem Klick vollständige Exportdateien für
              Dokumentation, Nachweise und Kontrollen. Ohne zusätzlichen
              Papierkram, ohne Nacharbeit vor Prüfungen.
            </p>

            <div className="mt-7 font-heading text-lg sm:text-xl text-terracotta italic">
              Dokumentieren. Exportieren. Fertig.
            </div>

            <div className="mt-6 inline-flex items-center gap-3 bg-white/10 border border-white/15 rounded-full px-4 py-2">
              <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-terracotta text-white font-heading text-sm font-bold">
                3
              </span>
              <span className="font-body text-sm text-white/90">
                Anwendungen gratis testen · Download kostenlos · keine
                Kreditkarte
              </span>
            </div>

            <div className="mt-9 flex flex-wrap gap-3">
              <StoreButton platform="ios" testId={CTA_BOTTOM.appstore} />
              <StoreButton platform="android" testId={CTA_BOTTOM.playstore} />
            </div>
            <div className="mt-4">
              <ApkButton testId={CTA_BOTTOM.apk} variant="dark" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
